import { Button } from "@workspace/web-ui/components/button";
import { Form } from "@workspace/web-ui/components/form";
import { cn } from "@workspace/web-ui/lib/utils";
import { useUpdate } from "../hooks/use-update";
import { FormFieldType } from "../types";
import FormField from "./formfield/form-field";
import PasswordRequirement from "./password-requirement";
import { Loader2 } from "lucide-react";

const inputStyles = "rounded-lg border border-[#DCDEE3]";
const inputStylesError = "rounded-lg border-red-500 focus:border-red-500 focus:ring-red-500";

interface UpdatePasswordFormProps {
  token?: string;
}

const UpdatePasswordForm = ({ token }: UpdatePasswordFormProps) => {
    const { form, onSubmit, passwordRequirements , isLoading} = useUpdate({ token });

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="w-full space-y-6">
                <FormField 
                    control={form.control}
                    name="password"
                    label="Password"
                    type="password"
                    fieldType={FormFieldType.PASSWORD}
                    placeholder="Enter your password"
                    error={form.formState.errors.password?.message as string}
                    className={cn(inputStyles, form.formState.errors.password ? inputStylesError : "", "px-[16px] py-[20px]")}
                />

                


                <FormField 
                    control={form.control}
                    name="confirmPassword"
                    label="Confirm Password"
                    type="password"
                    placeholder="Confirm your password"
                    error={form.formState.errors.confirmPassword?.message as string}
                    fieldType={FormFieldType.PASSWORD}
                    className={cn(inputStyles, form.formState.errors.confirmPassword ? inputStylesError : "", "px-[16px] py-[20px]")}
                />


                {/* Password Requirements */}
                <div className="space-y-2 mt-2">
                 <PasswordRequirement 
              fulfilled={passwordRequirements.minLength} 
              text="At least 8 characters" 
            />
            <PasswordRequirement 
              fulfilled={passwordRequirements.hasUppercase} 
              text="One uppercase letter" 
            />
            <PasswordRequirement 
              fulfilled={passwordRequirements.hasLowercase} 
              text="One lowercase letter" 
            />
            <PasswordRequirement 
              fulfilled={passwordRequirements.hasNumber} 
              text="One number" 
            />
            <PasswordRequirement 
              fulfilled={passwordRequirements.hasSpecial} 
              text="One special character" 
            />
          </div>

                <Button 
                    type="submit" 
                    className="w-full px-[16px] py-[12px] h-10 rounded-[10px] bg-[#4272DD]"
                    disabled={isLoading}
                >
                  {isLoading ? <Loader2 className="animate-spin duration-200"/>: "Update Password"}
                </Button>
            </form>
        </Form>
    );
}

export default UpdatePasswordForm;